import React, { useEffect } from 'react';
import { css } from '@emotion/react';
import { Box, Typography } from '@mui/material';
import { useQueryFetch } from './useQueryFetch';
import { column } from './commonCSS';
import { stagger, useAnimate } from 'framer-motion';
//import {  } from '@mui/icons-material';

/* t = loadDataHOC('GET', '/account/org/get/info', {
	reactQuery: { queryName: 'getOrgInfo' } */

const childStyle = css({
	label: { opacity: 0 },
	div: { opacity: 0 }
});

const OrganizationInfoLabel = () => {
	const { data: orgData = [{}] } = useQueryFetch(
		'getOrgInfo',
		'/account/org/get/info',
		'GET'
	);
	const [, data] = orgData;
	const record = data?.[0] ?? {};
	const [scope, animate] = useAnimate();
	useEffect(() => {
		animate([
			['div', { scale: 0 }],
			[
				'div',
				{
					opacity: 1,
					scale: 1
				},
				{
					ease: 'circOut',
					duration: 0.4
				}
			],
			['label', { opacity: 1 }, { delay: stagger(0.04) }]
		]);
	}, []);

	return (
		<Box sx={[column, childStyle, { textAlign: 'end' }]} ref={scope}>
			<Typography color="primary" component="div">
				{record.full_name}
			</Typography>
            <Typography variant="caption" component="label">
				{record.address_1}
			</Typography>
            <Typography variant="caption" component="label">
				{record.address_2}
			</Typography>
            <Typography variant="caption" component="label">
				{record.city}
			</Typography>
            <Typography variant="caption" component="label">
				{record.state}
			</Typography>
            <Typography variant="caption" component="label">
				{record.phone}
			</Typography>
            <Typography variant="caption" component="label">
				{record.fax}
			</Typography>
        </Box>
    );
};
export default OrganizationInfoLabel;
